import { Observable } from "rxjs";
import { ContractMemberModel, ContractRoadmapModel, ContractStepModel, ContractWrapperModel, PaymentTransactionModel_Opt } from "../../../models/contract.model";
import { FinanceWalletModel, ForecastModel, ICreditLetter, IMultiPaymentStateCS } from "../../../models/finance.model";
import { ITaskTargetResponse } from "../../../models/task.model";
import { FileDataResponse } from "../../../services/api/documents-api.service";
import { IDivStyles } from "./contract-styling-consts";
export const contractStatusToModifyRM = ['open']
export const ContractStatusToAddTragets = ['open','verified']
export const ContractStatusToRunAutoReload = ['pre_verified','verified']
export const ContractStatusToRunAutoReloadOneSigner = ['open', 'renegotiated']
export interface ITagData {
  label:string,
  background:string,
  color:string,
  icon?:string,
  iconColor?:string,
  additional_icon?:string,
}
interface ITargetsData {
  files:{guid:string,data: FileDataResponse}[],
  tasks:{guid:string,data:ITaskTargetResponse}[],
  credit_letter:{guid:string,data:ICreditLetter}[],
  payments:{guid:string,data:PaymentTransactionModel_Opt}[],
  sub_contracts:{guid:string,data:ContractWrapperModel}[],
  multi_payments:{guid:string,data:IMultiPaymentStateCS}[]
}
export type TTargetData = FileDataResponse | ITaskTargetResponse| ContractWrapperModel |IMultiPaymentStateCS  | ICreditLetter  | PaymentTransactionModel_Opt;
export interface IContractTargetData {
  contractGuid:string, 
  targetData: ITargetsData
}
export interface IWallet {
  wallet: FinanceWalletModel
}
export interface IForecast {
  forecast: {forecast_total: ForecastModel; forecast_wallets: ForecastModel[]}
}
export interface IWalletFullData  {
  wallet: IWallet,
  forecast:IForecast,
  contractGuid:string
}
export interface IObsWalletFullData  {
  wallet: Observable<{wallet: FinanceWalletModel}>,
  forecast:Observable<{forecast: {forecast_total: ForecastModel; forecast_wallets: ForecastModel[]}}>,
  currentForecast:Observable<ForecastModel|{}>
}
export interface IVerifiedRoadmap {
    step_guid: string | null,
    target_key?: string,
    target_type?: string,
    contract_guid: string
}
export interface INewStep {
    action:'preView'|'add'|'none',
    stepType?:string
}
export interface IStepDataToOpen {
  contractGuid:string,
  contractStep:ContractStepModel|null
  stepDivData?: IDivStyles
}
export interface IContractDataModel {
  contract:ContractWrapperModel|null,
  contractRoadmap:ContractRoadmapModel|null,
  contractRoadmapCopyBeforeEdit:ContractRoadmapModel|null,
  memberIsEmptyProject:ContractMemberModel|null,
  currentProjectGuid:string,
  allSignatoriesInContract:ContractMemberModel[],
  membersInContract:ContractMemberModel[]
  rights:IContractRight
}
export interface IContractRight {
  isCurrentMemberCanAddTargetsAfter:boolean,
  isFinanceBlockAvailable:boolean,
  isUserVerifiedContract:boolean,
  isContractBlockedForEdit:boolean,
  isCurrentMemberInContract:boolean,
  isCurrentMemberSigner:boolean,
  buttonsDisabled : {
    replenishment?: boolean,
    barter?: boolean,
    payment?: boolean,
  }
}
export interface IMemberWithState {
  guid:string,
  state:boolean
}
export interface IRoadMapHistory {
  label: string; 
  roadmap: ContractRoadmapModel
}